import ToolbarLogo from '@flows/src/components/ui/advisory-flow/components/toolbar/ToolbarLogo';
import { Center } from '@wegroup/design-system';
import { FC, useContext } from 'react';
import { ThemeContext } from 'styled-components';
import useAuth from '../../../../app/src/features/authentication/hooks/useAuth';

const FlowProductsSideBarLogo: FC = () => {
  const { distribution } = useAuth();
  const theme = useContext(ThemeContext);

  const logoUrl = distribution?.logos?.logo || theme.branding?.logo;

  return (
    <Center maxW="3xs" mx="auto" mb="8" px="4">
      <ToolbarLogo url={logoUrl} />
    </Center>
  );
};

export default FlowProductsSideBarLogo;
